import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { QueryStatus, authAxios } from "../../../utils";
import { RootState } from "../../../redux/store";
import { ElectricVehicleApi } from "./electricVehiclesAPI";

export interface ElectricVehiclesState {
  electricVehiclesStatus: QueryStatus;
  electricVehicles: ElectricVehicleApi[];
}

const initialState: ElectricVehiclesState = {
  electricVehiclesStatus: "idle",
  electricVehicles: [],
};

export const getElectricVehiclesByCompanyAsync = createAsyncThunk(
  "getElectricVehiclesByCompanyAsync/call",
  async (_, thunkAPI) => {
    const company = (thunkAPI.getState() as RootState).home.company;
    if (!company) throw new Error("Company not selected");
    const axios = authAxios({ companyUuid: company.uuid });
    const response = await axios.get<ElectricVehicleApi[]>(
      `electric_charges/vehicles/company/${company.uuid}`,
    );
    return response.data;
  },
);

export const electricVehiclesSlice = createSlice({
  name: "electricVehicles",
  initialState,
  reducers: {
    resetElectricVehiclesStatus(state) {
      state.electricVehiclesStatus = "idle";
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getElectricVehiclesByCompanyAsync.pending, (state) => {
        state.electricVehiclesStatus = "processing";
      })
      .addCase(getElectricVehiclesByCompanyAsync.fulfilled, (state, action) => {
        state.electricVehiclesStatus = "success";
        state.electricVehicles = action.payload;
      })
      .addCase(getElectricVehiclesByCompanyAsync.rejected, (state) => {
        state.electricVehiclesStatus = "failed";
      });
  },
});

export const selectElectricVehiclesStatus = (state: RootState) =>
  state.electricVehicles.electricVehiclesStatus;

export const selectElectricVehicles = (state: RootState) =>
  state.electricVehicles.electricVehicles;

export default electricVehiclesSlice.reducer;
